import { render, staticRenderFns } from "./_forward_record_message_form.vue?vue&type=template&id=ca7a062a&scoped=true&"
import script from "./_forward_record_message_form.vue?vue&type=script&lang=js&"
export * from "./_forward_record_message_form.vue?vue&type=script&lang=js&"
import style0 from "./_forward_record_message_form.vue?vue&type=style&index=0&id=ca7a062a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7a062a",
  null
  
)

export default component.exports